import { uiActions, turnSelectors } from '~/store';
import { MAIN_SCREEN_MODALS } from '~/lib/constants';
import { getLocalStore } from '~/lib/helpers';
// ---- internal imports ----

function displayNextTurnConfirmation(state) {
	if (!shouldDisplay(state)) {
		return;
	}

	return uiActions.changeActiveModal(MAIN_SCREEN_MODALS.MISSOUT_CUSTOMERS);
}

function shouldDisplay(state) {
	return !didUserSetDontShow(state);
}

function didUserSetDontShow(state) {
	const dontShow = getLocalStore('dontShowMissoutOnCustomersModal') ?? {};
	const missoutScenario = turnSelectors.getMissoutScenario(state)
	return dontShow[missoutScenario] || !missoutScenario
}

export default displayNextTurnConfirmation;
